"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13107],{

/***/ 32522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ SOCIAL_MEDIA; },
/* harmony export */   "UE": function() { return /* binding */ PHONE_NUMBER; },
/* harmony export */   "Vr": function() { return /* binding */ EMAIL_LINK; },
/* harmony export */   "o4": function() { return /* binding */ ADDRESS; },
/* harmony export */   "zm": function() { return /* binding */ PLACEMENT_DATA; }
/* harmony export */ });

var EMAIL_LINK = "hi@yellow.systems";
var SOCIAL_MEDIA = {
    linkedin: {
        id: "linkedin",
        title: "LinkedIn",
        iconDark: "linkedinFilled",
        iconLight: "linkedinWhite",
        link: "https://www.linkedin.com/company/yellow-systems"
    },
    facebook: {
        id: "facebook",
        title: "Facebook",
        iconDark: "facebookDark",
        iconLight: "facebookWhite",
        link: "https://www.facebook.com/yellow.systems/"
    },
    twitter: {
        id: "twitter",
        title: "Twitter",
        iconDark: "twitterFilled",
        iconLight: "twitterWhite",
        link: "https://mobile.twitter.com/yellow_systems"
    },
    dribbble: {
        id: "dribbble",
        title: "Dribbble",
        iconDark: "dribbbleFilled",
        iconLight: "dribbbleWhite",
        link: "https://dribbble.com/yellow_systems"
    },
    behance: {
        id: "behance",
        title: "Behance",
        iconDark: "behanceFilled",
        iconLight: "behanceWhite",
        link: "https://www.behance.net/yellow_systems"
    },
    youtube: {
        id: "youtube",
        title: "YouTube",
        iconDark: "youtubeSocialFilled",
        iconLight: "youtubeWhite",
        link: "https://www.youtube.com/@yellowsystems9900"
    },
    instagram: {
        id: "instagram",
        title: "Instagram",
        iconDark: "instagramFilled",
        iconLight: "instagramWhite",
        link: "https://www.instagram.com/yellow.systems/"
    }
};
var PHONE_NUMBER = {
    us: "+1 (940) 601 6017"
};
var ADDRESS = {
    us: {
        addressCountry: "USA",
        addressLocality: "San Francisco",
        streetAddress: "44 Tehama St",
        postalCode: "94105"
    },
    ar: {
        addressCountry: "Argentina",
        addressLocality: "Buenos Aires",
        streetAddress: "Av. Corrientes 1312",
        postalCode: "C1043ABN"
    },
    pl: {
        addressCountry: "Poland",
        addressLocality: "Warszawa",
        streetAddress: "Grzybowska 62",
        postalCode: "00-855"
    },
    cy: {
        addressCountry: "Cyprus",
        addressLocality: "Larnaca",
        streetAddress: "Agias Faneromenis, 143, Flat 201",
        postalCode: "6031"
    }
};
var PLACEMENT_DATA = {
    USA: [
        "".concat(ADDRESS.us.streetAddress, " ").concat(ADDRESS.us.addressLocality, " ").concat(ADDRESS.us.postalCode), 
    ],
    Poland: [
        "".concat(ADDRESS.pl.addressLocality, " ").concat(ADDRESS.pl.postalCode),
        ADDRESS.pl.streetAddress, 
    ],
    Argentina: [
        "".concat(ADDRESS.ar.streetAddress, " ").concat(ADDRESS.ar.postalCode),
        ADDRESS.ar.addressLocality, 
    ]
};


/***/ }),

/***/ 13107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "En": function() { return /* binding */ CATEGORY; },
/* harmony export */   "IR": function() { return /* binding */ websiteMicrodata; },
/* harmony export */   "UB": function() { return /* binding */ addresses; },
/* harmony export */   "WN": function() { return /* binding */ aboutPageMicrodata; },
/* harmony export */   "_c": function() { return /* binding */ localBusinessMicrodata; },
/* harmony export */   "jh": function() { return /* binding */ professionalServiceMicrodata; },
/* harmony export */   "jn": function() { return /* binding */ OFFERS; },
/* harmony export */   "nW": function() { return /* binding */ organisationMicrodata; },
/* harmony export */   "pt": function() { return /* binding */ logoUrl; }
/* harmony export */ });
/* unused harmony export webpageMicrodata */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96076);
/* harmony import */ var utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32522);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20281);







var defaultDescription = "✔ We provide software development services for startups and businesses. ✔ Reach out for a free consultation!";
var nameData = {
    name: "Yellow",
    alternateName: "Yellow Systems"
};
var SERVICE_CATEGORY = {
    fintech: "Fintech Development Services",
    mobile: "Mobile Development Services",
    web: "Web Development Services"
};
var logoUrl = "".concat(utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .rootUrl */ .Wd).concat(utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .IMAGES.roundLogo */ .Y_.roundLogo);
var addresses = [
    (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        "@type": "PostalAddress"
    }, utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .ADDRESS.us */ .o4.us), {
        telephone: utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .PHONE_NUMBER.us */ .UE.us
    }),
    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        "@type": "PostalAddress"
    }, utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .ADDRESS.cy */ .o4.cy),
    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        "@type": "PostalAddress"
    }, utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .ADDRESS.ar */ .o4.ar),
    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        "@type": "PostalAddress"
    }, utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .ADDRESS.pl */ .o4.pl), 
];
var _obj;
var CATEGORY = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.lendingSoftwareDevelopment.slug */ .y2.lendingSoftwareDevelopment.slug, SERVICE_CATEGORY.fintech), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.mvpDevelopment.slug */ .y2.mvpDevelopment.slug, SERVICE_CATEGORY.mobile), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.cloudDevelopment.slug */ .y2.cloudDevelopment.slug, SERVICE_CATEGORY.web), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.tradingSoftwareDevelopment.slug */ .y2.tradingSoftwareDevelopment.slug, SERVICE_CATEGORY.fintech), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.aiDevelopment.slug */ .y2.aiDevelopment.slug, SERVICE_CATEGORY.web), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.mlDevelopment.slug */ .y2.mlDevelopment.slug, SERVICE_CATEGORY.web), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.dataScienceDevelopment.slug */ .y2.dataScienceDevelopment.slug, SERVICE_CATEGORY.web), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.discoveryPhase.slug */ .y2.discoveryPhase.slug, SERVICE_CATEGORY.web), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.erpDevelopment.slug */ .y2.erpDevelopment.slug, SERVICE_CATEGORY.web), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.customChatApp.slug */ .y2.customChatApp.slug, SERVICE_CATEGORY.web), _obj);
var _obj1;
var OFFERS = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.lendingSoftwareDevelopment.slug */ .y2.lendingSoftwareDevelopment.slug, [
    {
        name: "P2P lending solutions development",
        description: "Empower your P2P lending platform with our top-notch software development services, " + "designed to enhance user experience and maximize profitability."
    },
    {
        name: "Crowdfunding platforms development",
        description: "Transform your crowdfunding vision into reality with our expert software development " + "services that deliver seamless and secure platforms tailored to your unique needs."
    },
    {
        name: "Credit risk reporting",
        description: "Optimize your credit risk management strategy with our comprehensive credit risk reporting " + "software, designed to provide accurate insights and actionable recommendations."
    },
    {
        name: "Mortgage solutions development ",
        description: "Streamline the mortgage process and improve customer experience with our customized " + "software development solutions for mortgage lenders and brokers."
    },
    {
        name: "Document management software development",
        description: "Efficiently manage your documents with our robust and scalable software development " + "solutions that automate document processing, storage, and retrieval."
    },
    {
        name: "Loans management software development",
        description: "Take control of your loan portfolio with our flexible and secure software development " + "solutions that streamline loan origination, servicing, and collections. "
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.mvpDevelopment.slug */ .y2.mvpDevelopment.slug, [
    {
        name: "Business analysis",
        description: "Prior to the MVP creation process, our team researches your app idea, business model, " + "target audience, and competitors in order to assess the market demands and preferences."
    },
    {
        name: "MVP prototyping",
        description: "A prototype is essential for the development of a real-world MVP. It reveals the " + "potential errors in the core design so that the team can fix them quickly and economically."
    },
    {
        name: "MVP UI/UX design",
        description: "An MVP may not be a full product, but it still requires design work so that users can " + "try it and provide substantive feedback."
    },
    {
        name: "MVP development",
        description: "We will support you in the creation, launch, and post-release support of an MVP. " + "Then, if you decide to continue working toward a full-scale project, we'll be ready."
    },
    {
        name: "MVP quality assurance",
        description: "Your product's MVP will be tested with the same set of tools we use for full-scale " + "projects. That way, we'll ensure that the MVP functions correctly."
    },
    {
        name: "MVP launch and support",
        description: "The Yellow team is ready to help you enter the market with your MVP so that you can " + "smoothly and efficiently up-scale the project to meet your needs."
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.cloudDevelopment.slug */ .y2.cloudDevelopment.slug, [
    {
        name: "Cloud migration",
        description: "Our specialists work closely with your team to migrate apps and infrastructures to " + "the cloud. We use proven and trusted migration methods to ensure your data's integrity and safety."
    },
    {
        name: "Cloud-native development",
        description: "Integrating cloud technology into your business will positively affect the core metrics " + "and facilitate scaling up and maintenance. We will help you realize the maximum potential of cloud-based solutions."
    },
    {
        name: "Cloud Computing Architecture",
        description: "Proper cloud architecture ensures all critical processes are correctly connected with " + "one another. We create service-oriented architectures to organize data flows."
    },
    {
        name: "Cloud app UI/UX design ",
        description: "If your cloud app needs to be designed from scratch or requires a redesign to meet user " + "needs and optimize flow, our team will take care of it."
    },
    {
        name: "Cloud app testing",
        description: "We plan the testing process and conduct both manual and automated tests to make sure " + "your cloud application will function as it should when delivered to the market."
    },
    {
        name: "Cloud app management",
        description: "Efficient management and maintenance of a cloud app is a key factor in its success. " + "We are prepared to organize the ideal management solutions to help you easily scale up your business."
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.tradingSoftwareDevelopment.slug */ .y2.tradingSoftwareDevelopment.slug, [
    {
        name: "Automated trading software development",
        description: "Allows financial institutions and professionals to profit from a wider range of " + "financial markets more quickly and easily"
    },
    {
        name: "Stock trading software development",
        description: "Our trading system development is user-friendly, secure, and compatible with " + "multiple operating systems and devices by request."
    },
    {
        name: "Security and data protection strategies",
        description: "To ensure that your business meets all requirements in the fast-changing and " + "extremely challenging world of FinTech."
    },
    {
        name: "Custom investment software development ",
        description: "With cutting-edge development tools developed by Yellow, you can make sure " + "your client satisfaction ratings and the number of great investment decisions will grow."
    },
    {
        name: "Data analysis",
        description: "Data is the new gold, especially in the FinTech market. Our custom solutions " + "make it comprehensive, which helps you make better trading decisions."
    },
    {
        name: "Cloud Computing",
        description: "Going cloud means more security and ease of use for your product. Many businesses " + "opt for cloud computing instead of worrying about hardware updates and get access online within seconds. "
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.aiDevelopment.slug */ .y2.aiDevelopment.slug, [
    {
        name: "Natural Language Processing",
        description: "This AI development service can be used to build voice assistants, gather data " + "about meaning and emotions, and build a more efficient communication strategy."
    },
    {
        name: "Custom AI applications",
        description: "Whether you want to analyze medical data, prepare a recommendation list for users, " + "predict prices for sales and marketing strategy, and reach any other of your business goals, our " + "specialists will analyze your requirements and create a perfect custom solution for them."
    },
    {
        name: "Computer vision",
        description: "Computer vision works almost like a human eye. It enables a machine to identify, " + "process, recognize, and understand all types of objects in images and videos. Yellow’s AI software " + "developers will help you integrate computer vision into your application, website, or platform."
    },
    {
        name: "Data analytics",
        description: "The process of structuring and analyzing data can be significantly sped up by implementing " + "artificial intelligence and machine learning algorithms. AI app development will ensure you receive " + "valuable insights and get organized reports with ease."
    },
    {
        name: "Neural networks",
        description: "A neural network is a set of algorithms that is trained to notice underlying relationships " + "in data and conduct predictive analysis."
    },
    {
        name: "Chatbots",
        description: "Our artificial intelligence developers are experienced in building AI-based chatbots " + "for websites and mobile apps. A chatbot empowered by AI algorithms can boost your customer service’s " + "productivity and positively affect user experience."
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.mlDevelopment.slug */ .y2.mlDevelopment.slug, [
    {
        name: "Machine learning development",
        description: "We offer advanced ML and neural network development for businesses of every scale from " + "small local startups to multinational enterprises. Specialists from Yellow are ready to build a " + "solution that will meet your needs and improve the processes you want to address."
    },
    {
        name: "Big data analysis",
        description: "Working with big data will provide you with definite patterns and valuable insights for " + "your sales and marketing teams. The Yellow team will build a suitable AI and machine learning solution " + "that will analyze raw data accurately."
    },
    {
        name: "Predictive algorithms",
        description: "Predictive analysis is a powerful tool for almost any business. With the help of your " + "existing data and ML models, you can predict the behavior of your customers and market conditions " + "in order to prepare for changes in advance."
    },
    {
        name: "Computer vision",
        description: "This service processes real-world photos and videos with capable algorithms. It can be " + "used in a variety of applications and perform countless functions ranging from face detection to vehicle tracking. "
    },
    {
        name: "Natural language processing (NLP)",
        description: "Machine learning solutions based on natural language processing algorithms can be used " + "for apps in various industries such as IoT, healthcare, smart homes, and business workflow optimization."
    },
    {
        name: "AI-powered chatbots",
        description: "Chatbots are automated solutions that empower your customer service, facilitate communication " + "with your clients, and boost internal workflow. They can work with the help of scripts, but AI-based " + "solutions are more personalized and efficient."
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.dataScienceDevelopment.slug */ .y2.dataScienceDevelopment.slug, [
    {
        name: "Image recognition",
        description: "Data science can help your security software recognize faces, identify emotions, " + "and determine the number of objects on the image."
    },
    {
        name: "Personalization",
        description: "With the help of big data and business intelligence, you can see the patterns of user " + "behavior and recommend new content to people based on their preferences."
    },
    {
        name: "Route optimization",
        description: "Machine learning and deep learning solutions will provide drivers with the most efficient " + "way to deliver the load based on traffic, weather, and GPS."
    },
    {
        name: "Price prediction",
        description: "Using predictive analytics, it's possible to predict the price of a real estate property " + "with the help of data science and machine learning algorithms."
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.discoveryPhase.slug */ .y2.discoveryPhase.slug, [
    {
        name: "Risk reduction",
        description: "A discovery phase will provide you and your team with the necessary data to decide " + "whether to continue development. You will know about possible risks and be prepared for them."
    },
    {
        name: "User validation",
        description: "When you have a clickable prototype on your hands, you can do more than just show " + "it to stakeholders or investors; you can also beta test groups of your target audience to receive real user feedback."
    },
    {
        name: "Cost reduction",
        description: "The discovery phase in software development is not costly compared to the full-scale " + "process, so if you decide that the idea is not worth the risk, your final expenses will be minimal."
    },
    {
        name: "Transparent goals",
        description: "A discovery phase will give your team a clear understanding of the project. They will know " + "why each feature is needed and what user pain point it solves."
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.erpDevelopment.slug */ .y2.erpDevelopment.slug, [
    {
        name: "ERP consulting services",
        description: "It all starts with a detailed and careful analysis of your current business environment to " + "identify where it needs the help of a custom ERP solution. The findings allow us to formulate strategies " + "to integrate and migrate critical ERP software."
    },
    {
        name: "Custom ERP development",
        description: "To automate and speed up business processes, make them more transparent and get insights from " + "them, we develop custom ERP solutions for enterprises of different sizes and from different industries. " + "They are scalable and are available from different kinds of devices."
    },
    {
        name: "Expert ERP implementation",
        description: "Yellow's skilled and experienced specialists will deploy your custom ERP system with data " + "integrity and zero downtime. You'll get a comprehensive and easy-to-use system that is aimed at simplifying " + "the business management and taking it to the next level."
    },
    {
        name: "ERP application development",
        description: "This module makes working with data easy as one-two-three from any device. Usually, web apps " + "give the full functionality, desktop apps are suitable for certain software modules that require complex UI, " + "and mobile apps are great if you need data on-the-go to make decisions fast and stay updated."
    },
    {
        name: "Human Resource management",
        description: "There's no longer need in creating multiple folders to create, implement and store contracts " + "and other documents. With the HRM module, you can assign and manage tasks, schedule calls, get comprehensive " + "reports, and much more."
    },
    {
        name: "Seamless data migration",
        description: "We use next-gen technologies to make data migration from your current ERP platform to a new one " + "easy and smooth. Since the security of the data is of primary importance for all businesses today, we adopt " + "the newest strategies to ensure that this process is 100% safe and secure."
    },
    {
        name: "ERP dashboards",
        description: "Having all critical information from multiple reports displayed in one screen is priceless. " + "Collected data is used to track KPIs and performance, enable predictive analytics, get insights and facilitate " + "decision-making process."
    },
    {
        name: "ERP system support and maintenance",
        description: "ERP development services usually include support and maintenance because business needs change fast, " + "just like today's business environment. That said, the ERP system may also need some adjustments for better functioning."
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.customChatApp.slug */ .y2.customChatApp.slug, [
    {
        name: "Communication",
        description: "You can easily stay in touch with friends, family and colleagues, share text and multimedia " + "messages, make audio and video calls, and much more."
    },
    {
        name: "Sales",
        description: "Having an instant messaging app is a great way to connect with customers. It makes communication " + "quick, clear and thorough, ensuring a comfortable purchase experience."
    },
    {
        name: "Customer Service",
        description: "With customer service chat, you'll demonstrate the willingness to help customers with their " + "issues and solve them as quickly as possible."
    }, 
]), _obj1);
var webpageMicrodata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    "@context": _utils__WEBPACK_IMPORTED_MODULE_6__/* .context */ .Do,
    "@type": "WebPage"
}, nameData);
var professionalServiceMicrodata = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    address: addresses,
    "@context": _utils__WEBPACK_IMPORTED_MODULE_6__/* .context */ .Do,
    "@type": "ProfessionalService"
}, nameData), {
    url: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .getPageUrl */ .XW)(),
    sameAs: Object.values(utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .SOCIAL_MEDIA */ .CL).map(function(item) {
        return item.link;
    }),
    priceRange: "$$-$$$$",
    telephone: utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .PHONE_NUMBER.us */ .UE.us,
    email: utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .EMAIL_LINK */ .Vr
});
var localBusinessMicrodata = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    "@context": _utils__WEBPACK_IMPORTED_MODULE_6__/* .context */ .Do,
    "@type": "LocalBusiness"
}, nameData), {
    description: defaultDescription,
    address: addresses,
    url: utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .rootUrl */ .Wd,
    image: logoUrl,
    telephone: utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .PHONE_NUMBER.us */ .UE.us,
    priceRange: "$$-$$$$",
    email: utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .EMAIL_LINK */ .Vr
});
var websiteMicrodata = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    "@context": _utils__WEBPACK_IMPORTED_MODULE_6__/* .context */ .Do,
    "@type": "WebSite"
}, nameData), {
    description: defaultDescription,
    url: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .getPageUrl */ .XW)(),
    image: logoUrl,
    sameAs: Object.values(utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .SOCIAL_MEDIA */ .CL).map(function(item) {
        return item.link;
    })
});
var organisationMicrodata = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    "@context": _utils__WEBPACK_IMPORTED_MODULE_6__/* .context */ .Do,
    "@type": "Organization"
}, nameData), {
    email: utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .EMAIL_LINK */ .Vr,
    url: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .getPageUrl */ .XW)(),
    logo: logoUrl,
    address: addresses
});
var aboutPageMicrodata = {
    "@context": _utils__WEBPACK_IMPORTED_MODULE_6__/* .context */ .Do,
    "@type": "AboutPage",
    name: "About Us | Yellow",
    description: "✔ Meet the team behind our web and mobile apps. ✔ Skilled techies and great people. Yellow - we are the people!",
    url: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .getPageUrl */ .XW)(utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.company.path */ .y2.company.path),
    sameAs: Object.values(utils_constants_contacts__WEBPACK_IMPORTED_MODULE_4__/* .SOCIAL_MEDIA */ .CL).map(function(item) {
        return item.link;
    }),
    image: logoUrl
};


/***/ }),

/***/ 20281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ context; },
/* harmony export */   "RK": function() { return /* binding */ getPersonMicrodata; },
/* harmony export */   "T8": function() { return /* binding */ getFaqMicrodata; },
/* harmony export */   "WK": function() { return /* binding */ getArticleMicrodata; },
/* harmony export */   "XW": function() { return /* binding */ getPageUrl; },
/* harmony export */   "fi": function() { return /* binding */ getServiceMicrodata; },
/* harmony export */   "js": function() { return /* binding */ getBreadcrumbsMicrodata; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32924);
/* harmony import */ var utils_constants_contacts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32522);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);




function getServiceOutput(output) {
    return {
        "@type": "Thing",
        name: output
    };
}
function getOfferCatalog(name) {
    var offers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return {
        "@type": "OfferCatalog",
        name: name,
        itemListElement: offers.map(function(offer) {
            return {
                "@type": "Offer",
                itemOffered: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                    "@type": "Service"
                }, offer)
            };
        })
    };
}
function getServiceChannel(serviceUrl) {
    return {
        "@type": "ServiceChannel",
        serviceUrl: serviceUrl,
        name: "Ready to get started?",
        description: "Fill in this form orsend us an e-mail",
        servicePhone: {
            "@type": "ContactPoint",
            telephone: utils_constants_contacts__WEBPACK_IMPORTED_MODULE_2__/* .PHONE_NUMBER.us */ .UE.us,
            name: "Yellow Sales Contact Point",
            description: "Yellow Sales phone number",
            contactType: "sales",
            availableLanguage: {
                "@type": "Language",
                name: "English",
                alternateName: "en"
            }
        }
    };
}
function getPlace(address) {
    return {
        "@type": "Place",
        address: address
    };
}
function getAuthor(param) {
    var _author = param.author, fullName = _author.fullName, position = _author.position;
    return {
        "@type": "Person",
        name: fullName,
        jobTitle: position
    };
}
function getAboutArticle(param) {
    var metaTitle = param.metaTitle, headImage = param.headImage, author = param.author, organisationMicrodata = param.organisationMicrodata, publishedAt = param.publishedAt, updatedAt = param.updatedAt;
    return {
        "@type": "Article",
        headline: metaTitle,
        image: headImage,
        author: getAuthor({
            author: author
        }),
        publisher: organisationMicrodata,
        datePublished: publishedAt,
        dateModified: updatedAt
    };
}
var context = "https://schema.org";
function getPageUrl() {
    var pagePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat(utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .rootUrl */ .Wd).concat(pagePath);
}
function getFaqMicrodata(param) {
    var faqList = param.faqList;
    var mainEntity = faqList.map(function(param) {
        var question = param.question, answer = param.answer, longAnswer = param.longAnswer;
        return {
            "@type": "Question",
            name: question,
            acceptedAnswer: {
                "@type": "Answer",
                text: answer || (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToPlainTextString */ .a)(longAnswer)
            }
        };
    });
    return {
        "@context": context,
        "@type": "FAQPage",
        mainEntity: mainEntity
    };
}
function getBreadcrumbsMicrodata() {
    var breadcrumbsList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (breadcrumbsList.length === 0) {
        return null;
    }
    var items = breadcrumbsList.map(function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            name: breadcrumb.title,
            item: getPageUrl(breadcrumb.to)
        };
    });
    return {
        "@context": context,
        "@type": "BreadcrumbList",
        itemListElement: items
    };
}
function getArticleMicrodata(param) {
    var metaTitle = param.metaTitle, title = param.title, publishedAt = param.publishedAt, updatedAt = param.updatedAt, headImage = param.headImage, articleBody = param.articleBody, author = param.author, organisationMicrodata = param.organisationMicrodata;
    return {
        "@context": context,
        "@type": "BlogPosting",
        headline: metaTitle,
        name: title,
        datePublished: publishedAt,
        dateModified: updatedAt,
        image: headImage,
        articleBody: articleBody,
        publisher: organisationMicrodata,
        author: getAuthor({
            author: author
        }),
        about: getAboutArticle({
            metaTitle: metaTitle,
            headImage: headImage,
            author: author,
            organisationMicrodata: organisationMicrodata,
            publishedAt: publishedAt,
            updatedAt: updatedAt
        })
    };
}
function getServiceMicrodata(page, param) {
    var organisationMicrodata = param.organisationMicrodata, category = param.category, addresses = param.addresses, offers = param.offers;
    return {
        "@context": context,
        "@type": "Service",
        provider: organisationMicrodata,
        name: page.title,
        alternateName: "".concat(page.title, " | Yellow"),
        description: page.description,
        providerMobility: "dynamic",
        category: category,
        serviceType: page.title,
        availableChannel: getServiceChannel(getPageUrl(page.path)),
        areaServed: getPlace(addresses),
        serviceOutput: getServiceOutput(page.title),
        hasOfferCatalog: getOfferCatalog(page.title, offers)
    };
}
function getPersonMicrodata(param) {
    var name = param.name, url = param.url, image = param.image, sameAs = param.sameAs, jobTitle = param.jobTitle, description = param.description;
    return {
        "@context": context,
        "@type": "Person",
        name: name,
        url: url,
        image: image,
        sameAs: sameAs,
        jobTitle: jobTitle,
        description: description,
        worksFor: {
            "@type": "Organization",
            name: "Yellow"
        },
        memberOf: {
            "@type": "Organization",
            name: "Yellow"
        }
    };
}


/***/ })

}]);